import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  applyLeaveRequest: ["leave_id"],
  applyLeaveSuccess: ["data"],
  applyLeaveFailure: ["status"],
});

export const ApplyLeaveTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  fetching: null,
  success: null,
  error: null,
  leave_id: null,
  data: null,
  status: null,
});

export const ApplyLeaveSelectors = {
  getData: (state: any) => state.applyLeave.data,
  isFetching: (state: any) => state.applyLeave.fetching,
  isSuccess: (state: any) => state.applyLeave.success,
  hasError: (state: any) => state.applyLeave.error,
};

export const request = (state: any, { leave_id }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    leave_id,
    data: null,
    status: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { data } = action;
    const updateData = {
    fetching: false,
    success: true,
    error: false,
    data: data,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any, action: any) => {
  const { status } = action;
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    status: status,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.APPLY_LEAVE_REQUEST]: request,
  [Types.APPLY_LEAVE_SUCCESS]: success,
  [Types.APPLY_LEAVE_FAILURE]: failure,
});
